export const perimeterPalette = ['#e2e8f0', '#BAE6FD', '#DDD6FE', '#FEF3C7']

export const referencesPalette = ['#A7F3D0', '#7DD3FC']
